// extracted by css-extract-rspack-plugin
export default {"ThreadSnippet":"ThreadSnippet-module__ThreadSnippet__CnWpD"};